import React, { useEffect, Fragment, useState, useMemo } from "react";

import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";

import "./style/style.scss";
import "./style/animation.scss";
import getContentById from "../../../../shared/utils/getContentById";
import parseMediaUrl from "../../../../shared/functions/parseMediaUrl";
import TeamLogo from "../../_partials/TeamLogo";
import _ from "lodash";
import { getShortPlayerName } from "../../../../shared/feeds/worldcup/playerHelper";
import Functions from "../../../../shared/components/MediaLibrary/EditModal/functions";
import { getImageFilterStyle, getWrapperDimensions, MAX_HEIGHT, MAX_WIDTH } from "../../../../shared/components/MediaLibrary/EditModal/ImageEditorModal";
import CanvasEditor from "image-arts";
import { DEFAULT_ADJUSTMENTS } from "../../../constants/constants";

const getMainBackground = (format) => {
  if (format === "1200x1500") {
    return _.get(assets, `mainbackground_1200`);
  }

  if (format === "1080x1920") {
    return _.get(assets, `mainbackground_1080`);
  }
};

export const getScaleSize = (format, ratio) => {
  const [w, h] = format.split('x').map(Number);

  if (ratio === 0 || ratio === 0.56) {
    return {
      width: w / MAX_WIDTH,
      height: h / MAX_HEIGHT
    };
  } else if (ratio === 1.78) {
    return {
      width: w / MAX_HEIGHT,
      height: h / MAX_WIDTH
    };
  } else if (ratio === 0.8) {
    return {
      width: w / (MAX_HEIGHT * 0.8),
      height: h / (MAX_HEIGHT)
    };
  }
}

const Index = ({ animation, data, mode, format, _searchParams, ...props }) => {
  const templateName = data?.template_name ?? "";
  const id = `${templateName}_${data?.uuid}`;

  const backgroundImage = getMainBackground(format);

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          id,
          data,
          format,
          apiSetup: props?.apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    if (mode === "screenshot") {
      const videoBg = $(`#${id} video.custom-background`).get(0);
      if (videoBg) {
        videoBg.addEventListener(
          "loadedmetadata",
          function () {
            this.currentTime = 3;
            this.pause();
          },
          false,
        );
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const { options, fields, dynamic, editData } = data.data || {};

  const { matchDetails = {}, teamSide } = data?.data?.dynamic || {};

  const liveLineup = _.get(dynamic, "lineup");

  const customLineupPlayers = getContentById("lineup_players", fields);
  const customLineupPlayersData = getContentById("lineup_players", fields, 'data');
  const customLineup = customLineupPlayersData.filter(player =>
    customLineupPlayers.includes(player.id)
  );
  const customAdditionalLineup = getContentById("additional_lineup", fields);
  customAdditionalLineup?.map((element => {
    if (element) {
      customLineup.push({
        shirtNumber: element.shirtNumber,
        label: element.label
      });
    }
  }));

  const sortedCustomLineup = [...customLineup];
  sortedCustomLineup.sort((a, b) => a.shirtNumber - b.shirtNumber);

  const customReservePlayers = getContentById("reserve_players", fields);
  const customReservePlayersData = getContentById("reserve_players", fields, 'data');
  const customReserve = customReservePlayersData.filter(player =>
    customReservePlayers?.includes(player.id)
  );
  const customAdditionalReserve = getContentById("additional_reserve", fields);
  customAdditionalReserve?.map((element => {
    if (element) {
      customReserve.push({
        shirtNumber: element.shirtNumber,
        label: element.label
      });
    }
  }));
  // const customReserve = getContentById("reserve", fields);

  const imageSide = getContentById("imageSide", fields) || "left";
  const homeTeam = data?.event?.home;
  const awayTeam = data?.event?.away;
  const competitionId = data?.event?.competitionId;

  const liveLineupData =
    teamSide === "home"
      ? _.find(liveLineup, { contestantId: homeTeam?.id })
      : _.find(liveLineup, { contestantId: awayTeam?.id });

  const sortedLiveLineupData = liveLineupData;
  sortedLiveLineupData?.player.sort((a, b) => a.shirtNumber - b.shirtNumber);

  const playerList = _.get(liveLineupData, "player");

  const customBackground = getContentById("background", fields, "self");
  const customBackgroundStyles = _.get(
    customBackground,
    `styles.${format}`,
    {},
  );
  const [layers, setLayers] = useState([]);
  const defaultEffects = {
    isBlur: false,
    isOpacity: false,
    isGradient: false,
    isShadow: false,
    resize: 100,
    ratio: 0,
    ratioUrl: "",
    prevRatio: 0,
  }
  const [effects, setEffects] = useState(defaultEffects)

  useEffect(() => {
    const initialLayers = editData?.layers;
    const initialEffects = editData?.effects;

    if (initialLayers) {
      setTimeout(() => {
        setLayers(initialLayers);
        setEffects(initialEffects ?? effects);
        if (initialEffects?.ratio > 0) {
          // prevRatioRef.current = initialEffects?.ratio;
        }
      }, 500);
    }
    if (!initialLayers && !editData) {
      const getBackgroundUrls = () => {
        const background = getContentById("background", fields, "self");
        const values = background?.value;
        if (!Array.isArray(values)) return [];

        return values.map((val) => parseMediaUrl(_.get(val, "url", "")));
      }
      const backgroundUrls = getBackgroundUrls();
      const initializeLayers = async () => {
        const newLayerPromises = backgroundUrls.map(async (url, index) => {
          const functions = new Functions(url);
          const finalUrl = functions.getUrl();
          const newDimension = getWrapperDimensions(effects.ratio);
          const newLayer = {
            id: Date.now() + index,
            imageUrl: finalUrl,
            backgroundUrl: url,
            functions,
            dimensions: { width: newDimension.width, height: newDimension.height },
            originalDimensions: { width: newDimension.width, height: newDimension.height },
            nonRatioDimensions: { width: newDimension.width, height: newDimension.height },
            adjustments: DEFAULT_ADJUSTMENTS,
            x: 0,
            y: 0,
            nonRatioX: 0,
            nonRatioY: 0,
            zIndex: index + 1,
            backgroundAndResize: {
              removebg: false,
              removebgUrl: "",
              changebg: false,
              changebgUrl: ""
            },
            isResizing: false,
            isRecreated: false,
          };

          return newLayer;
        });

        const addedLayers = await Promise.all(newLayerPromises);

        setLayers(addedLayers);
        // prevRatioRef.current = 0.56; //default
        setEffects(defaultEffects)
      }
      initializeLayers();
    }
  }, [editData, fields])

  const [ratioSize, setRatioSize] = useState({
    width: 4.075,
    height: 4.075
  });

  useEffect(() => {
    const ratio = effects.ratio;
    setRatioSize(getScaleSize(format, ratio));
  }, [effects])

  return (
    <div
      id={id}
      className={`T_${templateName} ${animation ? "animation" : ""} image-side-${imageSide}`}
    >
      <TemplateBlock>
        <div className={"custom-background-container"}>
          <div
            id={_.get(customBackground, "id", null)}
            style={{ ...customBackgroundStyles }}
            className={"custom-background"}
          >
            {layers
              .map((layer, index) => {
                const { id, zIndex, adjustments, imageUrl, dimensions, x, y } = layer;
                return <div
                  style={{
                    position: 'absolute',
                    width: `${dimensions.width * ratioSize.width}px`,
                    height: `${dimensions.height * ratioSize.height}px`,
                    // objectFit: `${_.isEmpty(customBackgroundStyles)} ? "cover" : ""`,
                    left: `${x * ratioSize.width}px`,
                    top: `${y * ratioSize.height}px`,
                    ...getImageFilterStyle(adjustments)
                  }}
                  key={id}
                >
                  <img
                    src={imageUrl}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: "cover"
                    }}
                  />

                </div>
              })}
          </div>
        </div>

        <div className={`wc-content content`} style={{ zIndex: 101 }}>
          <div className={`logo-container`}>
            <div className={`home`}>
              <TeamLogo team={homeTeam} competitionId={competitionId} />
            </div>
            <div className={`away`}>
              <TeamLogo team={awayTeam} competitionId={competitionId} />
            </div>
          </div>
          <div className={"player-list"}>
            {sortedCustomLineup?.length > 0
              ? sortedCustomLineup.map((p, index) => {
                return p && (
                  <div key={'starter-' + p?.label} className={"starter"}>
                    <span className={"shirt-number"}>{p?.shirtNumber}</span>
                    {p?.label?.toUpperCase()}
                  </div>
                );
              })
              : sortedLiveLineupData?.player
                .filter((p) => p.position !== "Substitute")
                .map((p, index) => {
                  return (
                    <div key={index} className={"starter"}>
                      <span className={"shirt-number"}>{p.shirtNumber}</span>
                      {p?.shortLastName?.toUpperCase()}
                    </div>
                  );
                })}

            <div className={"substitutes"}>
              {customReserve?.length > 0
                ? customReserve.map((p, index) => {
                  return (
                    <span key={'sub-' + p?.label}>
                      {p?.label?.toUpperCase()}
                      {index < customReserve.length - 1 && ","}
                    </span>
                  );
                })
                : liveLineupData?.player
                  .filter((p) => p.position === "Substitute")
                  .map((p, index, players) => {
                    return (
                      <span key={index}>
                        {p?.shortLastName?.toUpperCase()}
                        {index < players.length - 1 && ","}
                      </span>
                    );
                  })}

              { }
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

export default Index;
